"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var TShirt = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M15.5874115,5.03467076 L20.6812827,7.03732985 C20.9287269,7.13461272 21.0567587,7.40853631 20.9726798,7.66077298 L19.9735662,10.6581139 C19.8862423,10.9200855 19.6030823,11.0616655 19.3411106,10.9743416 L16.9992245,10.1937129 L16.9992245,18 C16.9992245,18.5522847 16.5515093,19 15.9992245,19 L7.99922451,19 C7.44693976,19 6.99922451,18.5522847 6.99922451,18 L6.99922451,10.1937129 L4.65733839,10.9743416 C4.39536673,11.0616655 4.11220675,10.9200855 4.02488286,10.6581139 L3.02576922,7.66077298 C2.94169034,7.40853631 3.06972214,7.13461272 3.31716635,7.03732985 L8.41103757,5.03467076 C8.46931025,5.01176081 8.53136762,5 8.59398209,5 L15.4044669,5 C15.4670814,5 15.5291388,5.01176081 15.5874115,5.03467076 Z M11.9992245,9 C10.1968672,9 8.67293015,7.80794153 8.17281794,6.1692293 L4.12265254,7.78914527 L4.81545228,9.86754447 L7.34111063,9.02565835 C7.60308229,8.93833446 7.99922451,9.11148187 7.99922451,9.5 L7.99922451,18 L15.9992245,18 L15.9992245,9.5 C15.9992245,9.22385763 16.2559769,8.91625447 16.6573384,9.02565835 L19.1829967,9.86754447 L19.8757965,7.78914527 L15.8256311,6.1692293 C15.3255189,7.80794153 13.8015818,9 11.9992245,9 Z M14.8281222,6.00112137 L9.17032682,6.00112137 C9.58247967,7.16572794 10.6934248,8 11.9992245,8 C13.3050243,8 14.4159693,7.16572794 14.8281222,6.00112137 Z" })));
};
TShirt.displayName = 'TShirt';
exports.default = TShirt;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=TShirt.js.map